import * as React from "react";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import { toast } from "react-toastify";

export default function ConfirmActionPopup({ open, onClose, onConfirm, text }: any) {
  return (
    <Dialog
      open={open}
      onClose={onClose}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
    >
      <DialogTitle id="alert-dialog-title" sx={{ textTransform: "capitalize" }}>
        Confirm {text}
      </DialogTitle>
      <DialogContent>
        <DialogContentText id="alert-dialog-description">
          Are you sure you want to {text} this item?
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} variant="outlined" color="inherit" sx={{ borderColor: "#ccc" }}>
          Cancel
        </Button>
        <Button
          onClick={() => {
            onConfirm();
            toast.success(`Node ${text}d successfully!`);
          }}
          autoFocus
          variant="contained"
          color={text === "delete" ? "error" : "primary"}
        >
          {text}
        </Button>
      </DialogActions>
    </Dialog>
  );
}
